if (!customElements.get('carousel-tabs')) {
  customElements.define(
    'carousel-tabs',
    class CarouselTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.slider = this.querySelector('[data-flickity-config]');

        if (!this.slider) return;

        this.flickity = new Flickity(
          this.slider,
          JSON.parse(this.slider.getAttribute('data-flickity-config'))
        );

        this.cells = this.querySelectorAll('.carousel-tabs__cell');

        // Support the original class and the new luxury tab class
        this.pills = this.querySelectorAll(
          '.carousel-tabs__pill, .luxury-featured-tab'
        );

        if (!this.pills.length) return;

        // Make the first tab active on load
        this.updateActivePill(this.pills[0]);

        this.pills.forEach((pill) => {
          pill.addEventListener('click', this.bindPillClick.bind(this));
        });
      }

      bindPillClick(event) {
        const pill = event.currentTarget;
        const activeCategory = pill.dataset.cat;

        this.updateActivePill(pill);
        this.updateActiveCategory(activeCategory);
      }

      updateActivePill(pill) {
        this.pills.forEach((p) => {
          p.classList.remove(
            'bg-black',
            'text-white',
            'active'
          );

          p.setAttribute('aria-selected', 'false');
        });

        pill.classList.add('active');
        pill.setAttribute('aria-selected', 'true');

        // Keep the original pill styling if the class exists
        if (pill.classList.contains('carousel-tabs__pill')) {
          pill.classList.add('bg-black', 'text-white');
        }
      }

      updateActiveCategory(activeCategory) {
        let firstVisibleIndex = null;

        this.cells.forEach((cell, index) => {
          if (
            activeCategory === 'all' ||
            cell.dataset.cat === activeCategory
          ) {
            cell.style.display = '';

            if (firstVisibleIndex === null) {
              firstVisibleIndex = index;
            }
          } else {
            cell.style.display = 'none';
          }
        });

        this.flickity.reloadCells();
        this.flickity.resize();

        if (firstVisibleIndex !== null) {
          this.flickity.select(firstVisibleIndex);
        }
      }
    }
  );
}